import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import classNames from "classnames";

import { Bars3Icon, PowerIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useLocation, useNavigate } from "react-router-dom";
import { SettingIcon } from "../components/icons";
import VersionSwitcher from "../components/version-switcher";
import { useLayoutContext } from "../core/context/layout-context";
import { NavigationInterface } from "../core/models";
import { useThemeContext } from "../core/context/theme-context";
import { logout } from "../services/auth-service";
import useSignOut from 'react-auth-kit/hooks/useSignOut';
// import useAuthUser from 'react-auth-kit/hooks/useAuthUser';
import keycloakAuth from "../services/keycloak";

interface AsideProps {
  openAside: boolean;
}

export default function Aside({ openAside }: AsideProps) {
  const location = useLocation();
  const { selectChildren, navigations, handleChildren, asideWidth, setAsideWidth, mobileSidebarOpen, setMobileSidebarOpen } = useLayoutContext();
  const { color } = useThemeContext();

  const [isResizing, setIsResizing] = React.useState(false);

  const currentNavigation = navigations.find(
    (el: any) => el.href === location.pathname
  );
  const user = (() => {
    try {
      const u = sessionStorage.getItem("user");
      return u ? JSON.parse(u) : null;
    } catch (e) {
      return null;
    }
  })();
  // const auth = useAuthUser()
  const navigation = useNavigate();
  const signOut = useSignOut()

  // Handle Drag and Drop Resizing
  const handleMouseDown = (e: React.MouseEvent) => {
    if (!openAside) return;
    e.preventDefault();
    setIsResizing(true);
  };

  React.useEffect(() => {
    if (!isResizing) return;

    const handleMouseMove = (e: MouseEvent) => {
      e.preventDefault();
      setAsideWidth(e.clientX);
    };

    const handleMouseUp = () => {
      setIsResizing(false);
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";

    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseup", handleMouseUp);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
  }, [isResizing, setAsideWidth]);

  async function disconnect() {
    if (sessionStorage.getItem("loginType") === "keycloak") {
      try {
        // Perform frontend logout
        await keycloakAuth.logout();
      } catch (error) {
        console.log(error)
      }
    } else {
      logout().then(() => {
        sessionStorage.clear();
        signOut();
        navigation("/");
        window.location.reload();
      })
    }
    
    
  }
  const childrenElements = currentNavigation
    ? currentNavigation.children
        // Entries flagged `display: false` are kept in the config but hidden from the menu.
        .filter((item: { display?: boolean }) => item.display !== false)
        //@ts-ignore
        .map((item: NavigationInterface, i: number) => {
        if (user?.microservices?.includes(item?.app_type)) {
        }
        return (
          <li key={item.name} className={"w-full "+ (
            !user?.microservices?.includes(item?.app_type) && location.pathname == "crm-client"? "hidden":""
          )}>
            <div
              onClick={() => handleChildren(item.href)}
              className={classNames(
                selectChildren === item.href &&
                  `${
                    color === "green"
                      ? "bg-green-100 text-green-700"
                      : color === "purple"
                      ? "bg-purple-100 text-purple-700"
                      : color === "red"
                      ? "bg-red-100 text-red-700"
                      : color === "blue"
                      ? "bg-blue-100 text-blue-700"
                      : color === "brown"
                      ? "bg-stone-100 text-stone-700"
                      : "bg-gray-100 text-gray-700"
                  }`,
                `${
                  color === "green"
                    ? "hover:bg-green-100"
                    : color === "purple"
                    ? "hover:bg-purple-100"
                    : color === "red"
                    ? "hover:bg-red-100"
                    : color === "blue"
                    ? "hover:bg-blue-100"
                    : color === "brown"
                    ? "hover:bg-stone-100"
                    : "hover:bg-gray-100"
                }`,
                " group flex gap-x-3 items-center rounded-md p-3 cursor-pointer text-sm leading-6 font-semibold group mx-2"
              )}
            >
              <item.icon
                className={classNames(
                  i === 0 &&
                    `${
                      color === "green"
                        ? "text-green-600"
                        : color === "purple"
                        ? "text-purple-600"
                        : color === "red"
                        ? "text-red-600"
                        : color === "blue"
                        ? "text-blue-600"
                        : color === "brown"
                        ? "text-stone-600"
                        : "text-gray-600"
                    }`,
                  location.pathname === item.href
                    ? `${
                        color === "green"
                          ? "text-green-600"
                          : color === "purple"
                          ? "text-purple-600"
                          : color === "red"
                          ? "text-red-600"
                          : color === "blue"
                          ? "text-blue-600"
                          : color === "brown"
                          ? "text-stone-600"
                          : "text-gray-600"
                      }`
                    : `${
                        color === "green"
                          ? "text-green-500"
                          : color === "purple"
                          ? "text-purple-500"
                          : color === "red"
                          ? "text-red-500"
                          : color === "blue"
                          ? "text-blue-500"
                          : color === "brown"
                          ? "text-stone-500"
                          : "text-gray-500"
                      }`,
                  `${
                    color === "green"
                      ? "group-hover:text-green-600"
                      : color === "purple"
                      ? "group-hover:text-purple-600"
                      : color === "red"
                      ? "group-hover:text-red-600"
                      : color === "blue"
                      ? "group-hover:text-blue-600"
                      : color === "brown"
                      ? "group-hover:text-stone-600"
                      : "group-hover:text-gray-600"
                  }`,
                  "h-6 w-6 shrink-0 "
                )}
                aria-hidden="true"
              />
              <span
                className={classNames(
                  { "sr-only": !openAside },
                  "truncate",
                  `${
                    color === "green"
                      ? "group-hover:text-green-600"
                      : color === "purple"
                      ? "group-hover:text-purple-600"
                      : color === "red"
                      ? "group-hover:text-red-600"
                      : color === "blue"
                      ? "group-hover:text-blue-600"
                      : color === "brown"
                      ? "group-hover:text-stone-600"
                      : "group-hover:text-gray-600"
                  }`
                )}
              >
                {item.name}
              </span>
            </div>
            {location.pathname === "/campagnes" && i === 2 ? (
              <hr className="border-dashed mb-2 border-purple-100" />
            ) : (
              <></>
            )}
            {item?.separator?(
              <hr />
            ):(<></>)}
          </li>
        );
      })
    : null;

  return (
    <>
      <Transition.Root show={mobileSidebarOpen} as={Fragment}>
        <Dialog className="relative z-50 lg:hidden" onClose={setMobileSidebarOpen}>
          <Transition.Child
            as={Fragment}
            enter="transition-opacity ease-linear duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition-opacity ease-linear duration-300"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-900/80" />
          </Transition.Child>

          <div className="fixed inset-0 flex">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="-translate-x-full"
              enterTo="translate-x-0"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="translate-x-0"
              leaveTo="-translate-x-full"
            >
              <Dialog.Panel className="relative mr-16 flex w-full max-w-xs flex-1">
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute left-full top-0 flex w-16 justify-center pt-5">
                    <button
                      type="button"
                      className="-m-2.5 p-2.5"
                      onClick={() => setMobileSidebarOpen(false)}
                    >
                      <span className="sr-only">Close sidebar</span>
                      <XMarkIcon
                        className="h-6 w-6 text-white"
                        aria-hidden="true"
                      />
                    </button>
                  </div>
                </Transition.Child>

                <div className="flex grow flex-col gap-y-5 overflow-y-auto bg-white px-6 pb-2 ring-1 ring-white/10">
                  <div className="flex h-16 shrink-0 items-center">
                    <a href="/" onClick={() => setMobileSidebarOpen(false)}>
                      <span className="text-green-600 text-xl font-bold">
                        KU
                      </span>
                    </a>
                  </div>
                  <nav className="flex flex-1 flex-col">
                    <ul role="list" className="-mx-2 flex-1 space-y-1">
                      {navigations.map((elmt) => {
                        const item = elmt as NavigationInterface;

                        return (
                          <li key={item.name}>
                            <a
                              href={item.href}
                              onClick={() => setMobileSidebarOpen(false)}
                              className={classNames(
                                "text-gray-400 hover:text-white hover:bg-gray-800",
                                "group flex gap-x-3 rounded-md p-2 text-sm leading-6 font-semibold"
                              )}
                            >
                              <item.icon
                                className="h-6 w-6 shrink-0"
                                aria-hidden="true"
                              />
                              {item.name}
                            </a>
                          </li>
                        );
                      })}
                    </ul>
                    <div className="pt-4 mt-auto border-t border-gray-100 space-y-2">
                      <button
                        type="button"
                        onClick={() => disconnect()}
                        className="w-full flex items-center gap-x-3 rounded-md p-2.5 text-sm font-semibold text-red-500 hover:bg-red-50 transition-colors"
                      >
                        <PowerIcon className="h-6 w-6 shrink-0" aria-hidden="true" />
                        Deconnexion
                      </button>
                      <VersionSwitcher openAside={true} isMobile={true} />
                    </div>
                  </nav>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>

      {/* Static sidebar for desktop with drag-and-drop resizer */}
      <div
        style={{
          width: openAside ? `${asideWidth}px` : "80px",
        }}
        className={classNames(
          !isResizing && "transition-[width] duration-200 ease-in-out",
          "hidden lg:fixed lg:inset-y-0 lg:left-0 lg:z-40 lg:flex lg:flex-col bg-white shadow-xl select-none"
        )}
      >
        <nav className="pt-[54px] pb-6 flex flex-col justify-between h-full w-full overflow-y-auto tracking-scrollbar">
          <ul
            role="list"
            className={classNames(
              { "items-start w-full": openAside },
              { "items-center": !openAside },
              "flex flex-col w-full space-y-1"
            )}
          >
            {childrenElements}
          </ul>
          <ul className="w-full flex flex-col space-y-1 mt-auto shrink-0 pt-4 border-t border-gray-100 px-1">
            <li className="w-full">
              <a
                href={"#"}
                className={classNames(
                  `${
                    color === "green"
                      ? "hover:bg-green-100"
                      : color === "purple"
                      ? "hover:bg-purple-100"
                      : color === "red"
                      ? "hover:bg-red-100"
                      : color === "blue"
                      ? "hover:bg-blue-100"
                      : color === "brown"
                      ? "hover:bg-stone-100"
                      : "hover:bg-gray-100"
                  }`,
                  "group flex gap-x-3 rounded-md p-3 text-sm leading-6 font-semibold group mx-2"
                )}
              >
                <SettingIcon
                  className={classNames(
                    `${
                      color === "green"
                        ? "text-green-500 group-hover:text-green-600"
                        : color === "purple"
                        ? "text-purple-500 group-hover:text-purple-600"
                        : color === "red"
                        ? "text-red-500 group-hover:text-red-600"
                        : color === "blue"
                        ? "text-blue-500 group-hover:text-blue-600"
                        : color === "brown"
                        ? "text-stone-500 group-hover:text-stone-600"
                        : " text-gray-500 group-hover:text-gray-600"
                    }`,
                    "h-6 w-6 shrink-0 "
                  )}
                  aria-hidden="true"
                />
                <span
                  className={classNames(
                    { "sr-only": !openAside },
                    `${
                      color === "green"
                        ? "group-hover:text-green-600"
                        : color === "purple"
                        ? "group-hover:text-purple-600"
                        : color === "red"
                        ? "group-hover:text-red-600"
                        : color === "blue"
                        ? "group-hover:text-blue-600"
                        : color === "brown"
                        ? "group-hover:text-stone-600"
                        : "group-hover:text-gray-600"
                    }`
                  )}
                >
                  Settings
                </span>
              </a>
            </li>
            <li className="w-full">
              <a
                href={"#"}
                onClick={() => disconnect()}
                className={classNames(
                  `${
                     "hover:bg-red-100 text-red-500"
                  }`,
                  "group flex gap-x-3 rounded-md p-3 text-sm leading-6 font-semibold group mx-2"
                )}
              >
                <PowerIcon
                  className={classNames(
                    `${
                         "text-red-500 group-hover:text-red-600"
                    }`,
                    "h-6 w-6 shrink-0 "
                  )}
                  aria-hidden="true"
                />
                <span
                  className={classNames(
                    { "sr-only": !openAside },
                    `${
                      "group-hover:text-red-600"
                    }`
                  )}
                >
                  Deconnexion
                </span>
              </a>
            </li>
            <li className="w-full">
              <VersionSwitcher openAside={openAside} />
            </li>
          </ul>
        </nav>

        {/* Resizing Handle with hover and drag indicator */}
        {openAside && (
          <div
            onMouseDown={handleMouseDown}
            title="Glisser pour redimensionner la barre latérale"
            className={classNames(
              "absolute top-0 right-0 w-2.5 h-full cursor-col-resize z-50 flex items-center justify-center transition-colors group",
              isResizing
                ? "bg-purple-600/30"
                : "hover:bg-purple-500/20"
            )}
          >
            <div
              className={classNames(
                "w-0.5 h-8 rounded-full transition-all",
                isResizing
                  ? "bg-purple-700 h-16 w-1"
                  : "bg-gray-300 group-hover:bg-purple-600 group-hover:h-12"
              )}
            />
          </div>
        )}
      </div>
    </>
  );
}
